import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';

export const StyledPanel = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid ${COLORS.COLOR_BORDER_SECONDARY};
  border-radius: 0.5rem;
  padding: 1rem 1.25rem;
  background: ${COLORS.GRAY_7};
`;

export const StyledTitle = styled.h3`
  margin: 0 0 0.75rem;
  ${pickThemeFontStyles('14', '20', 'BOLD')};
  color: ${COLORS.TEXT_SECONDARY};
`;

export const StyledSearchWrapper = styled.div`
  margin-bottom: 0.75rem;

  & .ant-input-prefix {
    padding-right: 0.5rem;
  }
`;

export const StyledChipsWrap = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 0.5rem;
  min-height: 2rem;
  padding-inline: 0.25rem;
  overflow-y: auto;
`;

export const StyledEmpty = styled.p`
  margin: 0;
  ${pickThemeFontStyles('13', '18', 'NORMAL')};
  color: ${COLORS.TEXT_HINT};
`;
